const multiSplit = (value: string, separators: string[]) => {
  const [firstSeparator = null, ...restSeparators] = separators;

  if (!firstSeparator) return [value];

  let segments = value.split(firstSeparator);

  if (!restSeparators.length) return segments;

  const splitSegments = (separator: string) => {
    segments = segments.flatMap((segment) => segment.split(separator));
  };

  restSeparators.forEach(splitSegments);

  return segments;
};

const normalizeSearchValue = (value: string) =>
  value
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

const removeWhitespaces = (value: string) => value.replace(/\s+/g, '');

export { multiSplit, normalizeSearchValue, removeWhitespaces };
